import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Sofa, ChefHat, ShowerHead, DoorOpen, ArrowRight, TrendingUp } from 'lucide-react';
import { CardStats } from '@components/ui';
import { getMutfakStats } from '@mocks/materials/mutfak';
import { getBanyoStats } from '@mocks/materials/banyo';
import { getGardropStats } from '@mocks/materials/gardrop';
import { formatCurrency } from '../components/StockIndicator';

const subCategories = [
    { key: 'mutfak', label: 'Mutfak', path: '/insaat/icmekan/mutfak', icon: ChefHat, color: 'bg-orange-600', description: 'Dolap, tezgah, ankastre set, evye ve davlumbaz' },
    { key: 'banyo', label: 'Banyo & WC', path: '/insaat/icmekan/banyo', icon: ShowerHead, color: 'bg-blue-600', description: 'Vitrifiye, armatür, duş kabin ve aksesuar' },
    { key: 'gardrop', label: 'Gardırop & Dolaplar', path: '/insaat/icmekan/gardrop', icon: DoorOpen, color: 'bg-amber-600', description: 'Yatak odası vestiyer, antre dolabı, giyinme odası' },
];

export default function IcMekan() {
    const { selectedConstruction, showAllConstructions } = useSelector((state) => state.construction);
    const insaatId = showAllConstructions ? null : selectedConstruction?.id;

    const mutfakStats = getMutfakStats(insaatId);
    const banyoStats = getBanyoStats(insaatId);
    const gardropStats = getGardropStats(insaatId);

    const toplamMaliyet = mutfakStats.toplamMaliyet + banyoStats.toplamMaliyet + gardropStats.toplamMaliyet;

    return (
        <div className="p-4 md:p-6 space-y-6">
            <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-orange-500 to-amber-600 flex items-center justify-center">
                    <Sofa size={24} className="text-white" />
                </div>
                <div>
                    <h1 className="text-2xl font-bold text-text-primary">İç Mekan & Mobilya</h1>
                    <p className="text-text-secondary">
                        {showAllConstructions ? 'Tüm İnşaatlar' : selectedConstruction?.name || 'Seçili proje yok'}
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <CardStats title="Mutfak Kalemleri" value={`${mutfakStats.toplamKalem}`} icon={ChefHat} color="primary" />
                <CardStats title="Banyo Kalemleri" value={`${banyoStats.toplamKalem}`} icon={ShowerHead} color="info" />
                <CardStats title="Gardırop Kalemleri" value={`${gardropStats.toplamKalem}`} icon={DoorOpen} color="secondary" />
                <CardStats title="Toplam Maliyet" value={formatCurrency(toplamMaliyet)} icon={TrendingUp} color="warning" />
            </div>

            <div>
                <h2 className="text-lg font-semibold text-text-primary mb-4">Malzeme Kategorileri</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {subCategories.map((cat) => {
                        const Icon = cat.icon;
                        return (
                            <Link key={cat.key} to={cat.path}
                                className="group bg-bg-secondary rounded-xl p-5 border border-border-light hover:shadow-lg hover:border-primary/30 transition-all">
                                <div className="flex items-start justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className={`w-12 h-12 rounded-xl ${cat.color} flex items-center justify-center`}>
                                            <Icon size={24} className="text-white" />
                                        </div>
                                        <div>
                                            <h3 className="font-semibold text-text-primary group-hover:text-primary transition-colors">{cat.label}</h3>
                                            <p className="text-sm text-text-muted mt-1">{cat.description}</p>
                                        </div>
                                    </div>
                                    <ArrowRight size={20} className="text-text-muted group-hover:text-primary transition-colors" />
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
